import React, { Component } from 'react';

import { Access } from 'common';
import { Page, Breadcrumbs, Navigation } from 'components';

class Main extends Component {
  state = {
    breadcrumbs: [{ name: 'Home', to: '/' }, { name: 'Eventos', to: '' }],
    navigation: [
      { name: 'Lista de Eventos', to: '/events/list', hidden: !Access.hasPermissions('manage-events') },
      { name: 'Tipos de Eventos', to: '/events', hidden: !Access.hasPermissions('manage-events') },
    ],
  };

  render() {
    const { breadcrumbs, navigation } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Navigation items={navigation} />
      </Page>
    );
  }
}

export default Main;
